import { useEffect, useState } from 'react'

/**
 * Subscribes to a CSS media query and reflects its current `matches` value.
 * Re-subscribes if `query` changes. Returns `false` in environments without
 * `window.matchMedia` (SSR, jsdom without polyfill).
 */
export function useMediaQuery (query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mql = window.matchMedia(query)
    setMatches(mql.matches)
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return matches
}
